import { render, staticRenderFns } from "./event_notes_list.vue?vue&type=template&id=f6cf47b4&"
import script from "./event_notes_list.vue?vue&type=script&lang=js&"
export * from "./event_notes_list.vue?vue&type=script&lang=js&"
import style0 from "./event_notes_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports